// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1596182565984
      var cssReload = require("D:/project/uniFrame/uni-frame/node_modules/_mini-css-extract-plugin@0.8.2@mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  